'use client'

import { HttpTypes } from "@medusajs/types";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { googleAnalyticsEvent } from "../track/gtag-utils";
import { facebookAnalyticsEvent } from "../track/fbq-utils";
import { Wishlist } from "@/types/wishlist";

export type analyticsEvent =
    "remove_from_cart" |
    "add_to_wishlist" |
    "add_to_cart" |
    "login" |
    "sign_up" |
    "add_payment_info" |
    "purchase" |
    "add_shipping_info" |
    "refund" |
    "view_item_list" |
    "begin_checkout" |
    "view_cart" |
    "view_item"


export type analyticsEventData = {
    user_id?: string
    // 认证事件属性
    method?: string | null

    // 电子商务事件属性
    currency?: string | null
    value?: number | string | null
    items?: {
        item_id?: string | null
        item_name?: string | null
        price?: number | string | null
        quantity?: string | number | null
    }[] | null

    // 独立事件属性
    transaction_id?: string | null
    shipping?: string | null
    payment_type?: string | null
    item_list_id?: string | null
}

type analyticsFun = <T extends analyticsEvent>(event: T, data: analyticsEventData) => void;

export type AppContextValue = {
    user?: HttpTypes.StoreCustomer
    cart?: HttpTypes.StoreCart
    cartId?: string
    salesChannels?: HttpTypes.AdminSalesChannel[]
    analytics?: analyticsFun
    wishlist?: Wishlist[]
}

export const AppContext = createContext<AppContextValue>({})

export const useAppContext = () => {
    return useContext(AppContext);
}


export const AppContextProvider = ({ children, ...data }: AppContextValue & { children: React.ReactNode }) => {
    let analytics = useCallback<analyticsFun>((event, data) => {
        googleAnalyticsEvent(event, contextValue, data)
        facebookAnalyticsEvent(event, data)
    }, [])
    const contextValue = useMemo(() => ({
        ...data,
        analytics
    }), [data]);

    return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
}